import React from "react";

export function Error404() {
  return <main>This is page doesn't exist</main>;
}
